// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2874":"543fdbfe","3759":"98a43d8f","4064":"b6ef5ac1"}[chunkId] + ".chunk.css";
};